import BusinessTwoTone from '@mui/icons-material/BusinessTwoTone';
import { Avatar, Chip } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

interface OrganisationChipProps {
  organisation: {
    id: string;
    name: string;
  } | null;
  clickable?: boolean;
}

export default function OrganisationChip({
  organisation,
  clickable = true,
}: OrganisationChipProps) {
  const navigate = useNavigate();

  if (!organisation) {
    return (
      <Chip
        label="N/A"
        size="small"
        sx={{
          fontSize: '0.75rem',
        }}
      />
    );
  }

  return (
    <Chip
      avatar={
        <Avatar sx={{ bgcolor: 'primary.main', width: 24, height: 24 }}>
          <BusinessTwoTone sx={{ fontSize: 14, color: 'white' }} />
        </Avatar>
      }
      label={organisation.name}
      size="small"
      onClick={clickable ? () => navigate(`/app/organisations/${organisation.id}`) : undefined}
      sx={{
        cursor: clickable ? 'pointer' : 'default',
        fontSize: '0.75rem',
        ...(clickable && {
          '&:hover': {
            backgroundColor: 'action.hover',
          },
        }),
      }}
    />
  );
}
